module.exports = __webpack_public_path__ + "img/Thunder attack.b82f52ea.png";